import * as Yup from "yup";
import { TabOption } from "../../../../shared/components/FormTabHeader";


export enum OfferStatus {
  AKTIF = "AKTIF",
  PASIF = "PASIF",
}

export enum OfferSaleStatus {
  SATISA_ACIK = "SATISA_ACIK",
  SATISA_KAPALI = "SATISA_KAPALI",
}

export enum OperationType {
  AZALT = "AZALT",
  ARTTIR = "ARTTIR",
}

export const OFFER_TABS: TabOption<string>[] = [
   { key: 'form', title: 'Kampanya Fiyat Detayı' },
  { key: 'list', title: 'Kampanya Listesi' },
];


export interface IOfferModel {
 id: number | null 
  offerStatus: OfferStatus | null;
  offerSaleStatus: OfferSaleStatus | null;
  reservationSource: string;
  locations: string;
  startDate: string | null; 
  endDate: string | null;
  operation: OperationType | null;
  minDay: number | null;
  maxDay: number | null;
}

export type IOfferCreate = Omit<IOfferModel, "id">;


export const initialOffer: IOfferModel = {
  id: null, 
  offerStatus: null,
  offerSaleStatus: null,
  reservationSource: "",
  locations: "",
  startDate: null,
  endDate: null,
  operation: null,
  minDay: null,
  maxDay: null,
};


export const offerValidation = Yup.object().shape({
  offerStatus: Yup.mixed<OfferStatus>()
    .oneOf(Object.values(OfferStatus))
    .required("Teklif durumu zorunludur"),
  offerSaleStatus: Yup.mixed<OfferSaleStatus>()
    .oneOf(Object.values(OfferSaleStatus))
    .required("Satış durumu zorunludur"),
  //reservationSource: Yup.string().required("Rezervasyon kaynağı zorunludur"),
  //locations: Yup.string().required("Lokasyon bilgisi zorunludur"),
  startDate: Yup.date().nullable().required("Başlangıç tarihi zorunludur"),
  endDate: Yup.date()
    .nullable()
    .min(Yup.ref("startDate"), "Bitiş tarihi başlangıçtan önce olamaz")
    .required("Bitiş tarihi zorunludur"),
  operation: Yup.mixed<OperationType>()
    .oneOf(Object.values(OperationType))
    .required("Operasyon tipi zorunludur"),
  minDay: Yup.number()
    .nullable()
    .min(0, "Minimum gün en az 0 olmalıdır")
    .required("Minimum gün zorunludur"),
  maxDay: Yup.number()
    .nullable()
    .min(Yup.ref("minDay") as unknown as number, "Maksimum gün minimumdan küçük olamaz")
    .required("Maksimum gün zorunludur"),
});
